<template>
  <div class="container notes">
    <p>
      {{ $t("label.notes.misscalcNotice") }}
    </p>

    <p>
      {{ $t("label.notes.disclaimer") }}
    </p>

    <p>
      {{ $t("label.notes.taxSource") }}
    </p>
  </div>

</template>

<script>
export default {
  name: "Notes"
}
</script>

<style scoped>

</style>